import { Record, Map } from 'immutable'

import { createFromRaw } from './record'
import { BOOKMARKED_NOTE_IDS_FETCHED } from './actionTypes'

const InitialState = Record(
  {
    transient: new Map(),
    bookmarkedNoteIds: [],
    bookmarkedNotesLoaded: false,
  },
  'notes'
)

const reducer = (state = new InitialState(), action) => {
  switch (action.type) {
    case 'UPDATE_NOTE_ATTRIBUTES_START': {
      const { id, title } = action.payload
      return state.setIn(['transient', id], createFromRaw({ title }))
    }
    case BOOKMARKED_NOTE_IDS_FETCHED: {
      const { payload } = action
      return state
        .set('bookmarkedNoteIds', payload)
        .set('bookmarkedNotesLoaded', true)
    }
    case 'UPDATE_NOTE_ATTRIBUTES_FAILURE':
    case 'UPDATE_NOTE_ATTRIBUTES_SUCCESS': {
      const { id } = action.payload
      return state.deleteIn(['transient', id])
    }
    default: {
      return state
    }
  }
}

export default reducer
